<template>
  <JqxWindow ref="myWindow" :theme="'material'" :width="400" :height="300" :resizable="true" :isModal="true"
             :autoOpen="false">
    <div class="col-md"><strong>Ubicazioni</strong>
    </div>
    <div>
      <div style="margin-top: 5px;margin-left: 5px;">
        <div class="form-group">
          <label>Ubicazione</label>
          <br>
          <JqxInput :theme="'material'" ref="ubicazione"></JqxInput>
        </div>
        <div class="form-group">
          <label>Tipologia</label>
          <br>
          <JqxComboBox :autoDropDownHeight="true" :selectedIndex="0" ref="tipologia_stock" :popupZIndex="10000"
                       :displayMember="'descrizione'" :valueMember="'id'" :source="dataAdapterTipostock"
                       :theme="'material'"></JqxComboBox>
        </div>
        <div class="form-group">
          <label>Ordinamento</label>
          <br>
          <JqxInput :theme="'material'" ref="ordinamento"></JqxInput>
        </div>
      </div>
      <card>
        <div class="float-right">
          <JqxButton :theme="'material'" @click="saveParent">
            Save
          </JqxButton>

          <JqxButton :theme="'material'" @click="cancelParent">
            Cancel
          </JqxButton>
        </div>
      </card>
    </div>
  </JqxWindow>
</template>

<script>

  import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
  import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
  import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
  import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
  import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
  import JqxCheckBox from "~jqx/jqwidgets-vue/vue_jqxcheckbox.vue";

  export default {
    name: "UbicazioniDetails",
    components: {
      JqxInput,
      JqxNumberInput,
      JqxButton,
      JqxWindow,
      JqxComboBox,
      JqxCheckBox
    },
    data: function () {
      return {
        panels: [{size: 200}, {size: 200}],
        dataAdapterTipostock: new jqx.dataAdapter(this.sourcetipostock)
      }
    },
    beforeCreate: function () {
      this.sourcetipostock = {
        datatype: 'json',
        datafields: [
          {name: 'descrizione'},
          {name: 'id'},
        ],
        url: '/api/cruds/read?t=AnagraficaTipoStock&q=allforsourceinput'
      };
    },
    methods: {
      saveParent() {
        this.$parent.saveBtn();
      },
      cancelParent() {
        this.$parent.cancelBtn();
      },
    }
  }
</script>

<style scoped>
  .jqx-splitter {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/cruddetails/UbicazioniDetails.vue